import axiosInstance from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  async getCountries() {
    let response = await axiosInstance().get(`/home/countries`);

    return response;
  },

  async getCourseList(payload) {
    let response = await axiosInstance().get(`/home/search/list`, {
      params: payload,
    });

    return response;
  },

  async getUniversityDetails(payload) {
    const { university_id } = payload;

    let response = await axiosInstance().get(
      `/home/university/${university_id}`
    );

    return response;
  },

  async getCountryDetails(payload) {
    const { country_key } = payload;

    let response = await axiosInstance().get(
      `/home/country-details/${country_key}`
    );

    return response;
  },

  async getFeaturedUniversities() {
    let response = await axiosInstance().get(`/home/featured-universities`);

    return response;
  },

  async getUniversityDetailsWithCourses(payload) {
    const { university_id } = payload;

    let response = await axiosInstance().get(
      `/home/university/${university_id}`
    );

    return response;
  },

  async getServicesAndPlans(payload) {
    let response = await axiosInstance().get(`/home/services-and-plans`, {
      params: payload,
    });

    return response;
  },

  async getCareersJobs() {
    return axiosInstance().get(`/home/careers/jobs`);
  },

  async saveSef(payload) {
    let response = await axiosInstance().post(`/home/sef`, payload);
    return response;
  },

  async sendCareerFormMail(payload) {
    let response = await axiosInstance().post(`/home/career-form`, payload);
    return response;
  },

  async sendFeedbackFormMail(payload) {
    let response = await axiosInstance().post(`/home/feedback-form`, payload);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/apiServices/homeServices.js